import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'

/**
 * i18n configuration
 */
import './i18n';

/**
 * Material UI
 */
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <App />
        </ThemeProvider>
    </React.StrictMode>,
)
